"use strict";
var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var {
    Input
} = require("react-bootstrap");
var CompanyStore = require("../../../stores/CompanyStore");
var CompanyActions = require("../../../actions/CompanyActions");
var _ = require("underscore");
var clone = require("clone");

var UserForm = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
      var account = CompanyStore.getState().account;
      var departments = CompanyStore.getState().departments;
      var departmentAccess = CompanyStore.getState().departmentAccess;
      var roles = CompanyStore.getState().roles;
      var rolesPerUser = companyStore.getState().rolesPerUser;

      var tree = this.makeTree(departments);

      return {
        id: this.props.user && this.props.user.id || "",
        username: this.props.user && this.props.user.username || "",
        password: "",
        first_name: this.props.user && this.props.user.first_name || "",
        last_name: this.props.user && this.props.user.last_name || "",
        email: this.props.user && this.props.user.email || "",
        is_active: this.props.user && this.props.user.is_active || false,
        is_staff: this.props.user && this.props.user.is_staff || false,
        access: this.props.user && this.props.user.access || {},
        newAccess: this.props.user && clone(this.props.user.access) || {},
        roles: this.props.user && this.props.user.roles || [],
        newRoles: this.props.user && clone(this.props.user.roles) || [],
        account: account,
        home_department: this.props.user && this.props.user.home_department || "",
        departments: departments,
        departmentTree: tree,
        departmentAccess: departmentAccess,
        allRoles: roles,
        rolesPerUser: rolesPerUser,
        hasSubmitted: false,
        formValidation: {
          nameValid: false,
          passwordValid: false,
          homeDepartmentValid: false,
        },
      };
    },
    componentDidMount: function() {
        CompanyStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
        CompanyStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.getInitialState());
    },
    makeTree(data) {
        var departments = _.indexBy(clone(data), 'id');

        var unflatten = function( array, parent, tree ){

            tree = typeof tree !== 'undefined' ? tree : [];
            parent = typeof parent !== 'undefined' ? parent : { id: null };

            var children = _.filter( array, function(child){
                //check if parent is in our list, if its not we set parent as null
                if(!departments[child.parent]){
                    child.parent = null;
                }
                return child.parent == parent.id;
            });

            if( !_.isEmpty( children )  ){
                if( parent.id == null ){
                   tree = children;
                }else{
                   parent['children'] = children
                }
                _.each( children, function( child ){ unflatten( array, child ) } );
            }

            return tree;
        }

        var tree = unflatten( data );

        return tree;
    },
    getUserDepartmentAccessData() {
        var old_access = clone(this.state.access);
        var access = clone(this.state.newAccess);
        var tree = clone(this.state.departmentTree);
        var id = this.state.id;

        var newData = [];

        function mapData(objects) {
            _.each(objects, function(department){
                if (access[department.id] >= 0) {
                    if (department.parent === null) {
                        newData.push({
                            "access": access[department.id],
                            "user": id,
                            "department": department.id
                        });
                    } else if(access[department.parent] > access[department.id] ){
                        newData.push({
                            "access": 0,
                            "user": id,
                            "department": department.id
                        });
                    } else if (access[department.parent] <= access[department.id] || access[department.parent] === 0 || !access[department.parent]) {
                        newData.push({
                            "access": access[department.id],
                            "user": id,
                            "department": department.id
                        });
                    }
                }

                if (department.children && department.children.length > 0) {
                    mapData(department.children);
                }

            })
        };
        mapData(tree);


        return newData;
    },
    onSubmit() {
      if (!this.props.user && (this.state.username === '' || this.state.password === '' || this.state.home_department === '')) {
        this.setState({
          hasSubmitted: true,
          formValidation: {
            usernameValid: this.state.username !== '',
            passwordValid: this.state.password !== '',
            homeDepartmentValid: this.state.home_department !== '',
          },
        });
      } else {
        this.props.onHide();
        // Initialize user object.
        var newUser = {
            "first_name": this.state.first_name,
            "last_name": this.state.last_name,
            "email": this.state.email,
            "is_active": this.state.is_active,
            "is_staff": this.state.is_staff,
            "home_department": this.state.home_department
        };

        if (this.props.user) {
            // In edit mode
            // Trigger an update request to the server.
            CompanyActions.updateUser({id: this.state.id, body: newUser});
        } else {
            // In add mode
            newUser["username"] = this.state.username;
            newUser["password"] = this.state.password;

            // Trigger a create request to the server.
            CompanyActions.addUser(newUser);
        }

        // Department acces data
        var data = this.getUserDepartmentAccessData();
        var departmentAccess = clone(this.state.departmentAccess);
        var new_access = clone(this.state.newAccess);

        var userDepartmentAccess = _.filter(departmentAccess, function(item){
            return item.user === this.state.id;
        }.bind(this));

        for (var i = 0; i < data.length; i++) {
            var access_object = data[i];
            var department_id = access_object.department;
            var shouldAdd = true;

            for (var j = 0; j < userDepartmentAccess.length; j++) {
                // Go through all prior access objects and check for a match.
                if (userDepartmentAccess[j].department === department_id && new_access[department_id] >= 0) {
                    shouldAdd = false;
                    // There exists an access object for this department.
                    if (new_access[department_id] === 0) {
                        // An access level of 0 triggers a delete.
                        // We only send a delete request for existing access objects.
                        CompanyActions.deleteUserDepartmentAccess(userDepartmentAccess[j].id);
                    } else if (new_access[department_id] !== userDepartmentAccess[j].access) {
                        // The department's new acess level is different from the current level.
                        // Send update request for the access object.
                        var dataObject = {
                            "id": userDepartmentAccess[j].id,
                            "body": access_object
                        }
                        CompanyActions.updateUserDepartmentAccess(dataObject);
                    }
                }
            }


            if (shouldAdd === true) {
                // Access object does not exist, add new.
                CompanyActions.addUserDepartmentAccess(data[i]);
            }
        }

        // =====
        // ROLES
        // =====

        var old_roles = clone(this.state.roles);
        var new_roles = clone(this.state.newRoles);

        for (i = 0; i < old_roles.length; i++) {
            var old_role = old_roles[i];
            if (new_roles.indexOf(old_role) === -1) {
                for (var j = 0; j < this.state.rolesPerUser.length; j++) {
                    var rolePerUser = this.state.rolesPerUser[j];
                    if (rolePerUser.role === old_role && rolePerUser.user === this.state.id) {
                        CompanyActions.deleteRolesPerUser(rolePerUser.id);
                    }
                }
            }
        }
        for (i = 0; i < new_roles.length; i++) {
            var new_role = new_roles[i];
            if (old_roles.indexOf(new_role) === -1) {
                var newRole = {
                    role: new_role,
                    user: this.state.id
                }
                CompanyActions.addRolesPerUser(newRole);
            }
        }
      }
    },
    selectDepartmentAccess(department, level) {
        var tree = clone(this.state.departmentTree);
        var newAccessData = [];
        var departments = clone(this.state.departments);
        // Get access list to set correct level on selected department.
        var access_list = clone(this.state.newAccess);
        var parent_level = access_list[department.id] || 0;
        if (parent_level >= level) {
            level--;
        }
        var super_parent_level = access_list[department.parent] || 0;
        if (super_parent_level > level) {
          // Sub departments can't have lower access level's than their parents.
          return;
        }
        var newTree = [];
        function minifyTree(object) {
          for (var i = 0; i < object.length; i++) {
            if (object[i].id === department.id) {
              newTree = [clone(object[i])];
              break;
            }

            if (object[i].children && object[i].children.length > 0) {
              minifyTree(object[i].children);
            }
          }
        }
        minifyTree(tree);

        function updateAccess(list, id) {
          for (var i = 0; i < list.length; i++) {
            var node = list[i];
            if (node.id === id) {
              // Node is parent, set access level.
              access_list[id] = level;
            } else if (node.parent === id) {
              // Node child.
              var node_access = access_list[node.id] || 0;
              if (node_access <= parent_level || node_access < level) {
                // Node's access level is lower or equal to parent.
                // Set access level.
                access_list[node.id] = level;
              }
            }
            if (node.children && node.children.length > 0) {
              updateAccess(node.children, node.id)
            }
          }
        }
        updateAccess(newTree, department.id);

        this.setState({newAccess: access_list});
    },
    mapIcons: function(tree) {
      return (
        <li key={tree.id}>
          <div className="tree-item checkbox-tree">
            <div className="tree-item-name">{tree && tree.name}</div>
            <div className="checkboxes">
              <Input
                type="checkbox"
                checked={this.state.newAccess[tree.id] >= 1}
                onChange={this.selectDepartmentAccess.bind(this, tree, 1)}
              />
              <Input
                type="checkbox"
                checked={this.state.newAccess[tree.id] >= 2}
                onChange={this.selectDepartmentAccess.bind(this, tree, 2)}
              />
              <Input
                type="checkbox"
                checked={this.state.newAccess[tree.id] >= 3}
                onChange={this.selectDepartmentAccess.bind(this, tree, 3)}
              />
              <Input
                type="checkbox"
                checked={this.state.newAccess[tree.id] >= 4}
                onChange={this.selectDepartmentAccess.bind(this, tree, 4)}
              />
            </div>
          </div>
          <ul>
            {(tree && tree.children && tree.children.length !== 0) ?
              tree.children.map((children) =>
                this.mapIcons(children)
              )
            :
              null
            }
          </ul>
        </li>
      );
    },
    mapDepartments: function(department) {
        var access = this.state.newAccess;
        var children = [];
        if (department.children){
            children = department.children;
        }
        return (
          <div className="tree-list">
            <ul className="first-ul">
              {this.mapIcons(department)}
            </ul>
          </div>
        );
    },
    toggleRole(role) {
        var newRoles = clone(this.state.newRoles);
        var index = newRoles.indexOf(role.id);
        if (index > -1) {
            newRoles.splice(index, 1);
        } else {
            newRoles.push(role.id);
        }
        this.setState({newRoles: newRoles});
    },
    mapRoles(role) {
      return (
        <Input
          key={role.id}
          label={role.name}
          type="checkbox"
          checked={this.state.newRoles.indexOf(role.id) !== -1}
          onChange={this.toggleRole.bind(this, role)}
        />
      );
    },
    mapDropdown(item, key) {
        return (<option key={key} value={item.id}>{item.name}</option>);
    },
    render() {
        return (
            <div className="modal-body">
                {this.props.user ?
                  null
                :
                  <Input
                    label="Notandanafn *"
                    type="text"
                    className={`${(this.state.hasSubmitted && !this.state.formValidation.usernameValid) ? 'error' : ''}`}
                    placeholder="Sláðu inn notandanafn"
                    valueLink={this.linkState("username")}
                  />
                }
                {this.props.user ?
                  null
                :
                  <Input
                    label="Lykilorð *"
                    type="password"
                    className={`${(this.state.hasSubmitted && !this.state.formValidation.passwordValid) ? 'error' : ''}`}
                    placeholder="Sláðu inn lykilorð"
                    valueLink={this.linkState("password")}
                  />
                }
                <div className="row">
                    <div className="col-md-6">
                        <Input
                            label="Fornafn"
                            type="text"
                            placeholder="Sláðu inn fornafn"
                            valueLink={this.linkState("first_name")}
                        />
                    </div>
                    <div className="col-md-6">
                        <Input
                            label="Eftirnafn"
                            type="text"
                            placeholder="Sláðu inn eftirnafn"
                            valueLink={this.linkState("last_name")}
                        />
                    </div>
                    <div className="col-md-6">
                        <Input
                            label="Tölvupóstur"
                            type="text"
                            placeholder="Sláðu inn tölvupóst"
                            valueLink={this.linkState("email")}
                        />
                    </div>
                    <div className="col-md-6">
                        <Input
                          label="Heimadeild"
                          type="select"
                          valueLink={this.linkState("home_department")}
                          className={`${(this.state.hasSubmitted && !this.state.formValidation.homeDepartmentValid) ? 'error' : ''}`}
                        >
                            <option key="default" value="">Veldu heimadeild</option>
                            {_.map(this.state.departments, this.mapDropdown)}
                        </Input>
                    </div>
                </div>
                <Input
                    label="Virkur notandi"
                    type="checkbox"
                    checkedLink={this.linkState("is_active")}
                />
                <Input
                    label="Admin notandi"
                    type="checkbox"
                    checkedLink={this.linkState("is_staff")}
                />
                {this.props.user ?
                    <div>
                      <strong>Aðgangstýring deilda</strong>
                      <div className="tree-header">
                        <div className="checkbox-labels">
                          <div>Lesa</div>
                          <div>Skrifa</div>
                          <div>Breyta</div>
                          <div>Eyða</div>
                        </div>
                      </div>
                      {_.map(this.state.departmentTree, this.mapDepartments)}
                      <strong>Hlutverk</strong>
                      {_.map(this.state.allRoles, this.mapRoles)}
                    </div>
                :
                    null
                }
            </div>
        );
    }
});

module.exports = UserForm;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Users/UserForm.js